import type { AgentDirection } from './types';

/**
 * Sensible defaults an admin can one-click prefill when adding an agent.
 * Kept client-side (no per-agent data needed): a universal tool baseline the
 * agents actually use over MCP, plus per-direction KB tags drawn from the
 * canonical KB-tag catalog. Prefill is additive (union with current), so it
 * never wipes a custom choice.
 */

/** The agent-facing MCP tools every agent uses in v1 (knowledge + results). */
export const RECOMMENDED_TOOLS: string[] = [
  'kb_search',
  'list_knowledge_bases',
  'save_result',
  'list_results',
  'get_result',
];

/** Recommended KB tags by direction — slugs from the canonical KB-tag catalog. */
export const RECOMMENDED_KB_TAGS: Record<AgentDirection, string[]> = {
  strategy: ['demand-radar', 'vertical-dossier', 'service-archetypes', 'pricing'],
  marketing: ['brand-voice', 'icp-persona', 'case-studies', 'agency-facts'],
  sales: ['service-archetypes', 'pricing', 'case-studies', 'vertical-dossier'],
  outbound_bd: ['brand-voice', 'icp-persona', 'case-studies', 'vertical-dossier'],
  talent: ['staffing', 'sops'],
  delivery: ['engagement-charter', 'runbooks', 'sops', 'case-studies'],
  engineering: ['spec', 'architecture', 'test-architecture', 'security-baseline', 'runbooks'],
  internal_ops: ['sops', 'security-baseline', 'legal-templates'],
};
